export default __webpack_public_path__ + "static/media/Rectangle 1151.de9f3a82.png";